import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

interface GeneralSettings {
  meta_description: string;
  favicon_url: string;
  logo_url: string;
}

const DEFAULTS: GeneralSettings = {
  meta_description:
    "Prvič računovodski servis, ki razume tvojo pot – od prvega računa do prvega investitorja.",
  favicon_url: "/favicon.jpg",
  logo_url:
    "https://swdwbeofkwiutzjdfrtc.supabase.co/storage/v1/object/public/blog-images/sangria-logo.png",
};

export const useGeneralSettings = () => {
  const [settings, setSettings] = useState<GeneralSettings>(DEFAULTS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data, error } = await supabase.functions.invoke(
          "get-public-settings",
        );
        if (!error && data) {
          setSettings({
            meta_description: data.meta_description || DEFAULTS.meta_description,
            favicon_url: data.favicon_url || DEFAULTS.favicon_url,
            logo_url: data.logo_url || DEFAULTS.logo_url,
          });
        }
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return { settings, loading };
};
